import * as Twilio from 'twilio-sync'
import { addEntry } from "../audit"

export default async function docUpdateAndLog<T extends object> (doc: Twilio.SyncDocument, obj: Partial<T>, docName?: string, optionalInfo?: string, isRetry?: boolean): Promise<boolean> {

  try {

    await doc.update(obj)

    return true

  } catch (e) {

    addEntry('PresenterService', 'DocumentUpdated',  `${docName} update was unsuccessful with ${obj}. ${optionalInfo ? optionalInfo : ''}. Error: ${e}`)

    if (!isRetry) {
      return new Promise(resolve => setTimeout(async () => {
          const res = await docUpdateAndLog(doc, obj, docName, optionalInfo, true)
          return resolve(res)
        }, 500)
      )
    }

    return false

  }

}
